import YoutubeEmbed from './YoutubeEmbed';
import useYoutubeVideo from '../../../../lib/hooks/video/useEmbeddedVideo';

export { YoutubeEmbed, useYoutubeVideo };
